import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { CustomizerComponentHeaderComponent } from '@app/customizer/components';
import { CaseListItemComponent } from '@app/customizer/components/case-list-item/case-list-item';
import { MiscModel } from '@models/misc-model';
import { ConfigurationService } from '@services/configuration.service';
import { ComponentVariantModel } from '@models/component-variant';
import { ConfigurationModel } from '@models/configuration';
import { ModelGroupModel } from '@models/model-group';
import { EventsService } from '@services/events.service';
import { DataApiService } from '../../../../_services/data-api.service';
import { ImageService } from '../../../../_services/image.service';
import { ComponentCodeConstants } from '../../../../shared/component-constants';
import { CustomizerMenuPartModel } from './../../../../_models/customizer-menu-part';
import { BaseCustomizerComponent } from './../../../../shared/base-customizer-component';

@Component({
    template: `
  <customizer-component-header [menu]="menu" (updateCollapsedOnComponent)="updateCollapsed($event)">
    @if (availableCases && availableCases.length) {
      <div id="case-list-container" class="inline-scroll">
        @for (case of availableCases; track case) {
          <case-list-item class="configuration-items"
            (click)="onSelect(case)"
            [attr.id]="case.EcommerceNoUnique"
            [ngClass]="{'is-selected': selectedCase !== null && case['EcommerceNoUnique'] === selectedCase['EcommerceNoUnique']}"
            [miscModel]="case"
            [image]="getImage"
            [selected]="selectedCase !== null && case['EcommerceNoUnique'] === selectedCase['EcommerceNoUnique']"
            [editMode]="state === customizerStateEnum.EDITORDER"
            [variantOrModelIsNew]="variantOrModelIsNew"
            >
          </case-list-item>
        }
      </div>
    }
  </customizer-component-header>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CustomizerComponentHeaderComponent, CaseListItemComponent, CommonModule
    ]
})
export class CaseComponent extends BaseCustomizerComponent implements AfterViewInit {

	public selectedIndex: number = 0;
	public availableCases: Array<MiscModel> = [];

	constructor(
		public override events: EventsService,
		public apiService: DataApiService,
		private imageService: ImageService,
		public override configurationService: ConfigurationService
	) {
		super(events, apiService, configurationService);
	}

	ngAfterViewInit(): void {
		setTimeout(() => this.scrollIntoView(), 500);
	}

	private scrollIntoView() {
		if (this.selectedCase) {
			const parent = document.getElementById('case-list-container');

			if (parent) {
				const item = parent.querySelector('[id="' + this.selectedCase.EcommerceNoUnique + '"]');

				if (item) {
					item.scrollIntoView({ behavior: 'smooth' });
				}
			}
		}
	}

	public static override shouldBeVisible = (modelGroup: ModelGroupModel | undefined, menuComponents: CustomizerMenuPartModel, variants: Array<ComponentVariantModel> | undefined, configurations: Array<ConfigurationModel>, demo: boolean, chosenCase?: MiscModel | null): boolean => {

		return !!modelGroup?.FullFrame && chosenCase != null;
	}

	async initData() {
		this.events.showLoader(true);

		this.availableCases = await this.fetchCases();

		this.events.showLoader(false);
	}

	onChanges(changes: SimpleChanges): void {

	}

	onSelect(model: MiscModel) {
		this.events.showLoader(true);
		this.updateCase(model);
	}

	getImage = (miscModelViewmodel: MiscModel) => {
		return this.imageService.GetMiscImage(miscModelViewmodel.EcommerceNoUnique, 1, "Large");
	}

	async fetchCases(): Promise<Array<MiscModel>> {
		const currentTemple = this.variants.find(x => x.Component.Code == ComponentCodeConstants.Temple);

		const cases = await this.configurationService.getCases(this.model.Id, this.modelSize, this.configuration?.ModelConfigurationUuid, this.modelGroup, currentTemple?.Component.Uuid, currentTemple?.Uuid, currentTemple?.VariantSize?.Uuid);

		return cases.map(t => t.MiscModel);
	}

}
